"use client"
import React, {useEffect, useState} from 'react';
import {Button} from "@/components/ui/button";
import SingleProductServices from "@/http/api/single-product/SingleProductServices";
import {SingleProductEnum} from "@/constants/commerce-enum";
import toast from "react-hot-toast";

const {addAvailable, cancelAvailable, checkAvailable} = new SingleProductServices();

const NotifyMeIfAvailable = ({unique_id}: { unique_id: string }) => {
    const [isSendNotifyAvailable, setIsSendNotifyAvailable] = useState<boolean | null>(null);


    useEffect(() => {
        const checkAvailableNotify = async () => {
            try {
                const isNotifySend: any = await checkAvailable(unique_id);
                setIsSendNotifyAvailable(isNotifySend?.productNotificationExists);
            } catch (error) {
                console.error("Error checking availability notification:", error);
            }
        };

        checkAvailableNotify();
    }, [unique_id]);

    const notifyAvailable = async () => {
        try {
            await addAvailable(unique_id);
            setTimeout(() => setIsSendNotifyAvailable(true), 1000);
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message, {
                position: "top-center"
            })
            console.log("ADD AVAILABLE ERROR:", error);
        }
    };
    const cancelAvailableHandler = async () => {
        try {
            await cancelAvailable(unique_id);
            setTimeout(() => setIsSendNotifyAvailable(false), 1000);
        } catch (error) {
        }
    };

    return (
        <div
            className={"w-full flex flex-wrap  px-[23px] py-[9px] items-center justify-between z-50 bg-white left-0 gap-2 border-b shadow-primary fixed bottom-[70px]"}>
            <p className={"text-xs font-medium text-right"}>{SingleProductEnum.notifMeIfProductBecomeAvailable}</p>
            <div className="w-full flex flex-wrap border-gray-200 items-center justify-center gap-[25px]">
                {isSendNotifyAvailable ? (
                    <Button
                        variant={"outline"}
                        className="w-full p-6 rounded-2xl overflow-hidden"
                        onClick={cancelAvailableHandler}
                    >
                        {SingleProductEnum?.cancelNotify}
                    </Button>
                ) : (
                    <Button
                        className="w-full p-6 rounded-2xl overflow-hidden"
                        onClick={notifyAvailable}
                    >
                        {SingleProductEnum?.notifyProduct}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default NotifyMeIfAvailable;